import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import {
    selectAllRegistration,
    selectUnconfirmedRegistrations,
} from "../../../../redux/slices/registrationSlice";
import { selectAllClassifications } from "../../../../redux/slices/classificationsSlice";
import { selectAllP2pSettings } from "../../../../redux/slices/p2pSettingsSlice";
import {
    selectCmsControlByIdByPage,
    selectCmsOptionByType,
} from "../../../../redux/slices/cmsSettingsSlice";
import { selectEmailVerificationInFlight } from "../../../../redux/slices/emailVerificationSlice";
import SaveAndContinue from "./SaveAndContinue";

const ConnectedSaveAndContinue = ({ handleClick, controlId }) => {
    const {
        ENUMS: { DefaultView, CMS_Control },
    } = constants;

    const registration = useSelector(selectAllRegistration);
    const { allowEarlyFormSubmissionRegistrationPage } = registration;
    const { remainingUnconfirmedRegistrations } = useSelector(
        selectUnconfirmedRegistrations,
    );
    const classifications = useSelector(selectAllClassifications);
    const p2pSettings = useSelector(selectAllP2pSettings);
    const { enableClassifications } = p2pSettings;

    const earlySubmissionLabel = useSelector((state) =>
        selectCmsOptionByType(
            CMS_Control.P2P_FOOTER_REGISTRATION_BUTTONS,
            "ifNoTotalCompleteButtonLabel",
            state,
        ),
    );

    const hasClassifications =
        enableClassifications && classifications.length > 0;

    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.REGISTRATION_DETAILS_STEP,
            state,
        ),
    );

    const {
        options: { nextButtonLabel = "Next" },
    } = control;

    const earlySubmissionButtonLabel =
        allowEarlyFormSubmissionRegistrationPage && earlySubmissionLabel
            ? earlySubmissionLabel
            : nextButtonLabel;

    const buttonLabel =
        remainingUnconfirmedRegistrations.length > 0
            ? "Confirm Details"
            : earlySubmissionButtonLabel;

    const emailVerificationInFlight = useSelector(
        selectEmailVerificationInFlight,
    );

    const saveAndContinueProps = {
        emailVerificationInFlight,
        hasClassifications,
        handleClick,
        buttonLabel,
    };
    return <SaveAndContinue {...saveAndContinueProps} />;
};

ConnectedSaveAndContinue.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
    handleClick: PropTypes.func.isRequired,
};

export default ConnectedSaveAndContinue;
